<template>
  <div>
    <header>
            <div class="headerOne">
               <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
                <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)"> -->
                <span class="buss">换绑手机号</span>
            </div>
    </header>
    <div>
        <ul>
            <li>
                <span>原手机号码</span>
                <!-- <span>{{phoneNum}}</span> -->
                <input type="text" v-model="oldNumber" class="firstInput" maxlength="11" placeholder="请输入" @blur="oldPhone">
            </li>
            <li>
                <span>新手机号码</span>
                <input type="text" placeholder="请输入" maxlength="11" v-model="phon" class="twoInput">
            </li>
             <li>
                <input type="text" placeholder="请输入四位短信验证码"  class="newIpnut" maxlength="4"  v-model="pass"> 
                <span class="send" @click="sev" v-show="isActiv" >发送</span>
                <!-- <input type="text" class="lastInput" maxlength="4" v-model="pass"> -->
            </li>
            <div class="news" v-show="!isActiv" @click="sev">
                <span>重发{{countOne}}s</span>
            </div>
        </ul>
    </div>
    <div class="sub" @click="toForm">
                完 成
          </div>
 
  </div>
</template>
<script>
import axios from "axios";
import { Toast } from 'mint-ui';

export default {
  data() {
    return {
      pass: "", //验证码
      phon: "", //新的手机号
      isActiv: true,
      secndes: true,
      countOne: 60,
      oldNumber:""  //原手机号
    };
  },
  computed: {
    phoneNum() {
      let phoneNum = this.$store.state.phoneNum;
      return phoneNum;
    },
    wsWbsocket() {
      return this.$store.state.wsWbsocket;
    }
  },
  methods: {
    // 原手机号输入框失去焦点
        oldPhone()
        {
           var regu1 = /^1\d{10}$/; 
            // 原手机号是否符合正则要求
            if(regu1.test(this.oldNumber)){
            
            }
            else
            {
              Toast({
                message: '请输入有效的手机号',
                position: 'top',
                duration: 2000
              });
            }
        },
        // 获取验证码      this.phoneNum===>之前的手机号
        sev() 
        {
          if(this.oldNumber==this.phoneNum){
                // 输入了新手机号码
          if(this.phon)
          {
              var regu1 = /^1\d{10}$/; 
              // 新手机号是否符合正则要求
              if(regu1.test(this.phon))
              {
                   console.log(2)
                 if(this.oldNumber)
                  {
                      var regu1 = /^1\d{10}$/; 
                      // 原手机号是否符合正则要求
                      if(regu1.test(this.oldNumber)){
                           var newMobile = '"' + "mobile" + '":' + '"' + this.phon + '"'; //新手机号
                          ws.send('{"action":"GetMobileLoginVerifyCodeIsUsedToChangeBindMobile",'+newMobile+"}");
                          ws.onmessage =(res) =>
                          { 
                            console.log(res)
                            var obj = JSON.parse(res.data);
                            this.numS = obj.s;
                            if (this.numS == 0) 
                            {    
                                  Toast({
                                      message: '发送成功',
                                      position: 'top',
                                      duration: 2000
                                    });
                                this.isActiv = false;
                                this.countOne = obj.nextTime;
                                var  one= this.countOne ;
                                (this.timer = setInterval(() => {
                                if (this.countOne > 1 && this.countOne <= one) 
                                {

                                  this.countOne--;
                                } 
                                else 
                                {
                                  this.isActiv = true;
                                  clearInterval(this.timer);
                                  this.timer = null;
                                  }
                              }

                              , 1000))
                             
                               
                            } 
                            else
                            {
                               this.isActiv = false;
                               this.countOne = obj.nextTime;
                               this.$toast({
                                  message: "发送失败",
                                  duration: 1500
                                });
                            }
                          }
                              
                      } 
                      else
                      {
                        Toast({
                            message: '请输入有效的手机号',
                            position: 'top',
                            duration: 2000
                          });
                      }
                  }
                  else
                  {
                    Toast({
                      message: '请输入原手机号',
                      position: 'top',
                      duration: 2000
                    });
                  }

              }
              else
              {
                Toast({
                    message: '请输入有效的手机号',
                    position: 'top',
                    duration: 2000
                  });
              }
          }
          else
          {
              Toast({
                    message: '请输手机号',
                    position: 'top',
                    duration: 2000
                  });
          }
          }
          else
          {
            Toast({
                    message: '原手机号输入错误',
                    position: 'top',
                    duration: 2000
                  });
          }
        
        },

        // 完成按钮
        toForm()
        {
              if (!this.phon || !this.pass) {
        this.$toast({
          message: "请输入正确的手机号",
          duration: 1500
        });
      }
      // alert(1)
      var regu2 = /^\d{4}$/;
      var pass = this.pass;
      if (regu2.test(pass)) {
        //校验换绑手机号
        //   console.log(phoneOne)
                var oldMobile = this.phoneNum; // 原来的手机号
                var newVerify = this.pass;    //验证码 
                var newMobile = this.phon;  //新手机号码
                 console.log(oldMobile)
                if (oldMobile == newMobile) {
                      this.$toast({
                          message: "原手机号输入错误",
                          duration: 1500
                      });
                } else {
                var mobileOne = '"' + "mobile" + '":' + '"' + oldMobile + '"'; //原手机号
                var mobileTwo = '"' + "newmobile" + '":' + '"' + newMobile + '"'; //新手机号
                var verifyOne = '"' + "verify" + '":' + '"' + newVerify + '"'; //验证码
                console.log(mobileOne, mobileTwo, verifyOne);
                ws.send(
                    '{"action":"RepleaceMobile",' +mobileOne +"," +mobileTwo +"," +verifyOne +"}"
                );
                ws.onmessage =(res) => {
                    console.log(res);
                    var obj = JSON.parse(res.data);
                    if (obj.s == 0) {
                    console.log(obj);
                      this.$store.commit("phone",this.phon)
                          this.$toast({
                              message: "换绑成功",
                              duration: 1500
                          });
                          
                    } else if(obj.s == 6002){
                        this.$toast({
                          message: "该手机号已注册",
                          duration: 1500
                    });
                    }else if(obj.s == 1023){
                      this.$toast({
                                  message: "验证码错误",
                                   duration: 1500
                    });
                    }else if(obj.s == 1023){
                      this.$toast({
                              message: "新手机号错误",
                              duration: 1500
                    });
                    }else if(obj.s == 1023){
                      this.$toast({
                              message: "验证码错误",
                             duration: 1500
                    });
                    }else if(obj.s == 1022){
                      this.$toast({
                              message: "无效的验证码",
                             duration: 1500
                    });
                    }

                    
                };
                }
      } 
      else {
         this.$toast({
          message: "请输入正确的验证码",
          duration: 1500
        });
      }
        },
    }
  }
</script>
<style scoped>
.newIpnut{

}
.twoInput{
  width: 4.2rem
}
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header {
  height: 1.6rem;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  position: relative;
}
.headerOne {
  font-size: 0;
}
.headerOne img {
  display: inline-block;
  margin-top: 0.3rem;
}
.headerOne img:nth-child(1) {
  margin-left: 0.2rem;
}
.headerOne .buss {
  display: inline-block;
  font-size: 0.55rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.firstInput{
    display: inline-block;
     /* text-indent: 2rem; */
        width: 4.2rem;
        text-align: right;
}
ul li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 1.7rem;
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.35rem;
}
ul li input {
  border: none;
  outline: none;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.55rem
}
ul li span {
  font-size: 0.55rem;
  line-height: 1.6rem;
  margin-left: 0.5rem;
}
ul li:nth-child(1) span:nth-child(2) {
  color: red;
  margin: 0;
}
ul li:nth-child(2) input {
  /* text-indent: 2rem; */
  text-align: right;
}
ul li:nth-child(3) input {
 margin-left: 0.5rem;
  display: inline-block;
  width:6rem;
  height: 1.2rem;
  /* margin-left:2.2rem; */
  text-indent: 0;
  background: rgba(0, 0, 0, 0.2);
  text-indent: 0.3rem;
 
 margin-top: 0.25rem;
  border-radius: 0.1rem;
}
input::-webkit-input-placeholder {  

font-size: 0.55rem;
 color: rgba(0, 0, 0, 0.5)
} 
.send {
   display: inline-block;
  width:2.4rem;
  height: 1.1rem;
  color: rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0.1rem;
  text-align: center;
  line-height: 1.1rem;
  margin-top: 0.3rem
}
.sub {
  color: white;
  font-size: 0.55rem;
  width: 90%;
  background-image: linear-gradient(to right, #2ea4b0, #06789d);
  margin: 0 auto;
  margin-top: 0.5rem;
  height:1.4rem;
  border-radius: 15px;
  text-align: center;
  line-height:1.4rem;
}
ul {
  position: relative;
}
.news {
  color: rgba(0, 0, 0, 0.5);
   width:2.4rem;
  height: 1.1rem;
   text-align: center;
  line-height: 1.1rem;
  font-size: 0;
  position: absolute;
  top:3.45rem;
  left:7rem;
  background: rgba(0, 0, 0, 0.2);
  margin-top: 0.3rem;
   border-radius: 0.1rem;
}
.news span {
  font-size: 0.55rem;
}
</style>



// WEBPACK FOOTER //
// src/components/change/numberChange.vue